import React from 'react'
import * as Layout from '../../../components/layout'
import * as Menu from '../../../components/menu'

export const routes = [
  {
    action: () => import(/* webpackChunkName: "ImportsErrorsPage" */'./component')
      .then(({ ImportsErrorsCountConnected }) => <Layout.Layout>
      <ImportsErrorsCountConnected />
      </Layout.Layout>),
    path: `${Menu.CONTENT_IMPORTS_ERRORS_URL}/:data_source_run_id`,
  },
]



// WEBPACK FOOTER //
// ./src/pages/imports/errors/routes.tsx